import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';

class Checker extends Component {
  static propTypes = {
    checkInit: PropTypes.func.isRequired,
    checkIsPending: PropTypes.bool.isRequired,
    checkPassed: PropTypes.bool.isRequired,
    children: PropTypes.element,
  };

  static defaultProps = {
    children: <div />,
  };

  componentDidMount() {
    if (this.props.checkIsPending) {
      this.props.checkInit();
    }
  }

  render() {
    const { checkIsPending, checkPassed, children } = this.props;
    return (
      <div>
        {checkIsPending
          ? (
            <div className="loader-container">
              <Loader active size="large" />
            </div>
          )
          : (
            <Fragment>
              { checkPassed
                ? (
                  <Fragment>{children}</Fragment>
                )
                : <Redirect to="/login" />
              }
            </Fragment>
          )
        }
      </div>
    );
  }
}

export default Checker;



// WEBPACK FOOTER //
// ./src/components/Checker/Checker.js